import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from 'src/shared/confirmation-modal/confirmation-modal.component';

export function openConfirmationModal(
  modalService: NgbModal,
  header: string,
  message: string,
  onConfirm: () => void,
  warningText?: string,
  onCancel?: () => void,
): void {
  const modalRef = modalService.open(ConfirmationModalComponent, {
    backdrop: 'static',
    size: 'md',
    centered: true,
  });

  modalRef.componentInstance.header = header;
  modalRef.componentInstance.message = message;

  if (warningText) {
    modalRef.componentInstance.warningText = warningText;
  }

  modalRef.result.then(
    (result) => {
      if (result) {
        onConfirm();
      } else {
        onCancel?.();
      }
    },
    () => onCancel?.(),
  );
}
